<template>
  <div class="modal offer-modal skin-modal contact-info-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="./../img/cross.svg" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b v-if="!ibanFormVisible">CONTACT INFORMATION</b>
                <b v-else>IBAN TRANSFER</b>
              </div>

              <!-- Step 1: Contact Information -->
              <div class="form-fields-wrapper" v-if="!ibanFormVisible">
                <label class="input-container">
                  <input type="text" placeholder="Name" v-model="name" />
                </label>
                <label class="input-container">
                  <input type="text" placeholder="Surname" v-model="surname" />
                </label>
                <label class="input-container">
                  <input
                    type="email"
                    placeholder="E-mail address"
                    v-model="email"
                  />
                </label>
                <label class="input-container">
                  <input type="tel" placeholder="Phone" v-model="phone" />
                </label>
                <label class="input-container">
                  <select v-model="country">
                    <option value="" disabled selected>Country</option>
                    <option
                      v-for="(item, i) in countryOptions"
                      :value="item"
                      :key="i"
                    >
                      {{ item.title }}
                    </option>
                  </select>
                </label>
                <label class="input-container">
                  <input type="text" placeholder="City" v-model="city" />
                </label>
                <label class="input-container">
                  <input type="text" placeholder="Address" v-model="address" />
                </label>
                <label class="input-container">
                  <input
                    type="text"
                    placeholder="Post Code"
                    v-model="postCode"
                  />
                </label>

                <div class="buttons buttons-special">
                  <button
                    v-if="$parent.payoutMethods && $parent.payoutMethods.card"
                    :class="['button', { disabled: !contactFieldsAreFilled }]"
                    @click="handleCardPayout"
                  >
                    <span class="payout-btn-content">
                      <img
                        v-if="$parent.payoutSettings && $parent.payoutSettings.card_logo"
                        :src="$parent.payoutSettings.card_logo"
                        alt="VISA"
                        class="payout-logo"
                      />
                      <span v-else>Pay with Card</span>
                    </span>
                  </button>
                  <button
                    v-if="$parent.payoutMethods && $parent.payoutMethods.sepa"
                    :class="[
                      'button',
                      'orange-btn',
                      { disabled: !contactFieldsAreFilled },
                    ]"
                    @click="showIbanForm"
                  >
                    <span>Continue with IBAN</span>
                  </button>
                </div>
              </div>

              <!-- Step 2: IBAN Details -->
              <div class="form-fields-wrapper" v-if="ibanFormVisible">
                <label class="input-container">
                  <input
                    type="text"
                    v-model="bank_holder_name"
                    placeholder="First Name"
                  />
                </label>
                <label class="input-container">
                  <input
                    type="text"
                    v-model="bank_holder_surname"
                    placeholder="Last Name"
                  />
                </label>
                <label class="input-container">
                  <input
                    type="text"
                    maxlength="34"
                    v-model="iban_number"
                    placeholder="IBAN"
                  />
                </label>
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">I agree with </span>
                        <router-link
                          v-if="privacyPolicyUrl"
                          :to="privacyPolicyUrl"
                          class="title"
                          >privacy policy</router-link
                        >
                        <span class="title"> and </span>
                        <router-link
                          v-if="termsAndConditionsUrl"
                          :to="termsAndConditionsUrl"
                          class="title"
                          >terms and conditions</router-link
                        >
                      </div>
                    </label>
                  </div>
                </div>
                <div class="buttons buttons-special">
                  <button
                    class="button orange-btn"
                    @click="ibanFormVisible = false"
                  >
                    <span>Back</span>
                  </button>
                  <button
                    :class="['button', { disabled: !sepaFieldsAreFilled }]"
                    @click="handleSepaPayout"
                  >
                    <span>Confirm Payout</span>
                  </button>
                </div>
              </div>

              <transition name="slide">
                <div v-if="$parent.error" class="error-desc desc red">
                  {{ $parent.error }}
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AcceptOfferModal",
  props: ["orderToView"],
  data: function () {
    return {
      ibanFormVisible: false,
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      terms: false,
      countryOptions: [],
      iban_number: "",
      bank_holder_name: "",
      bank_holder_surname: "",
    };
  },
  mounted() {
    this.getCounties();
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
      })
      .catch((res) => {
        if (res.response.status === 401) this.$parent.openSignIn();
      });
  },
  computed: {
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    privacyPolicyUrl() {
      const p = this.getPrivacyPage;
      return p ? { name: "TextPage", params: { identifier: p.slug } } : null;
    },
    termsAndConditionsUrl() {
      const p = this.getTermsPage;
      return p ? { name: "TextPage", params: { identifier: p.slug } } : null;
    },
    contactFieldsAreFilled() {
      return (
        this.name &&
        this.surname &&
        this.email &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    sepaFieldsAreFilled() {
      return (
        this.iban_number &&
        this.bank_holder_name &&
        this.bank_holder_surname &&
        this.terms
      );
    },
  },
  methods: {
    showIbanForm() {
      if (!this.contactFieldsAreFilled) return;
      this.$emit("setError", ""); // Clear previous errors
      this.ibanFormVisible = true;
    },
    handleApiError(res) {
      let errorMsg = "An unknown error occurred.";
      if (res.response && res.response.data) {
        if (res.response.data.errors) {
          errorMsg = Object.values(res.response.data.errors)[0][0];
        } else if (res.response.data.message) {
          errorMsg = res.response.data.message;
        }
      }
      this.$emit("setError", errorMsg);
    },
    handleCardPayout() {
      if (!this.contactFieldsAreFilled) return;
      this.$emit("setError", "");
      const data = {
        id: this.orderToView.id,
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        country: this.country.iso,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        currency: this.orderToView.currency,
      };

      this.$http
        .post(process.env.VUE_APP_API + "offer/request-payout/card", data)
        .then((res) => {
          if (res.data.status === "OK" && res.data.redirect_url) {
            window.location.href = res.data.redirect_url;
          } else {
            this.$emit(
              "setError",
              res.data.message || "Could not initiate card payout."
            );
          }
        })
        .catch(this.handleApiError);
    },
    handleSepaPayout() {
      if (!this.sepaFieldsAreFilled) return;
      this.$emit("setError", "");
      const data = {
        id: this.orderToView.id,
        account_number: this.iban_number,
        first_name: this.bank_holder_name,
        last_name: this.bank_holder_surname,
      };

      this.$http
        .post(process.env.VUE_APP_API + "offer/request-payout/sepa", data)
        .then(() => {
          this.$router.push({ path: "/offer-accepted-succes" });
          this.close();
        })
        .catch(this.handleApiError);
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) this.$parent.openSignInModal();
        });
    },
    close() {
      this.$emit("closeAcceptOfferModal");
    },
  },
  watch: {
    // When the modal is closed and reopened, reset its state
    "$parent.acceptOfferModalIsVisible"(newVal) {
      if (!newVal) {
        this.ibanFormVisible = false;
        this.terms = false;
        this.iban_number = "";
        this.bank_holder_name = "";
        this.bank_holder_surname = "";
      }
    },
  },
};
</script>

<style scoped>
.modal label {
  max-width: 100%;
}
.payout-btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.payout-logo {
  height: 35px;
  width: auto;
  object-fit: contain;
}
</style>
